/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactors_Nomarketharm4Inputs */

const id_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Ada Kerugian Pasar:`)
};

const ms_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada Kemudaratan Pasaran:`)
};

const da_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen Markedsskade:`)
};

const de_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Marktschädigung:`)
};

const en_us2_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Market Harm:`)
};

const es_es2_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin daño al mercado:`)
};

const es_mx2_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin daño al mercado:`)
};

const fil_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang Pinsala sa Merkado:`)
};

const fr_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun préjudice pour le marché :`)
};

const it_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun danno al mercato:`)
};

const hu_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs piaci kár:`)
};

const nl_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen marktschade:`)
};

const no_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen markedsskade:`)
};

const pl_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak szkody dla rynku:`)
};

const pt_br2_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum dano ao mercado:`)
};

const pt_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem danos ao mercado:`)
};

const ro_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fără prejudiciu pe piață:`)
};

const fi_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei haittaa markkinoille:`)
};

const sv_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen marknadsskada:`)
};

const vi_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không gây hại cho thị trường:`)
};

const tr_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazara Zarar Vermeme:`)
};

const cs_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez poškození trhu:`)
};

const bg_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без вреда за пазара:`)
};

const ru_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отсутствие вреда для рынка:`)
};

const uk_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відсутність шкоди ринку:`)
};

const ar_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا ضرر على السوق:`)
};

const hi_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई बाज़ार हानि नहीं:`)
};

const th_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่เป็นอันตรายต่อตลาด:`)
};

const ja_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市場への悪影響なし：`)
};

const zh_cn2_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无市场损害：`)
};

const zh_hant1_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無市場損害：`)
};

const ko_about_fairusefactors_nomarketharm4 = /** @type {(inputs: About_Fairusefactors_Nomarketharm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시장에 대한 피해 없음:`)
};

/**
* | output |
* | --- |
* | "No Market Harm:" |
*
* @param {About_Fairusefactors_Nomarketharm4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactors_nomarketharm4 = /** @type {((inputs?: About_Fairusefactors_Nomarketharm4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactors_Nomarketharm4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "ms") return ms_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "da") return da_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "de") return de_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "fil") return fil_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "fr") return fr_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "it") return it_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "hu") return hu_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "nl") return nl_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "no") return no_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "pl") return pl_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "pt") return pt_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "ro") return ro_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "fi") return fi_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "sv") return sv_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "vi") return vi_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "tr") return tr_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "cs") return cs_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "bg") return bg_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "ru") return ru_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "uk") return uk_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "ar") return ar_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "hi") return hi_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "th") return th_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "ja") return ja_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactors_nomarketharm4(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactors_nomarketharm4(inputs)
	return ko_about_fairusefactors_nomarketharm4(inputs)
});
export { about_fairusefactors_nomarketharm4 as "about.fairUseFactors.noMarketHarm" }